export const FORM_QUESTION_NOT_ANSWERED = 'FORM_QUESTION_NOT_ANSWERED';
export const PREQUAL_QUESTION_NOT_ANSWERED = 'PREQUAL_QUESTION_NOT_ANSWERED';

function notAnsweredQuestion({ id, mode, isForm }) {
  return {
    type: isForm ? FORM_QUESTION_NOT_ANSWERED : PREQUAL_QUESTION_NOT_ANSWERED,
    id,
    isAnswered: false,
    hasError: false,
    answer: '',
    mode
  };
}

export function questionNotAnswered(question) {
  return dispatch => dispatch(notAnsweredQuestion(question));
}
